<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="'Inquiry By Marketing Channels'" :directory="$t('report')" :icon="'grid'"/>
            </div>
            <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group row align-items-center">
                    <label for="inputs_semester" class="col-md-12" style="font-size: 16px;font-weight: 600;">
                        Semester
                    </label>
                    <app-input
                        id="inputs_semester"
                        class="col-sm-4"
                        v-model="input_semester"
						@input="setSemesterValue"
                        type="advance-search-select"
                        placeholder="Semester"
						:fetch-url="`report/get-semester`"
						list-value-field="nama"
                    />
                </div>
            </div>
            <div class="col-12">
                <app-overlay-loader v-if="preloader" />
            </div>
            <div class="col-md-6">
                
                <div class="card card-with-shadow border-0" v-if="!preloader" >
                    <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
                        <h5 class="card-title mb-0">{{ title_report }}</h5>
                    </div>
                    <div class="card-body">
                        <table class="table-Report"  :class="{ 'loading-opacity': preloader }">
                            <tr>
                                <th >Channels</th>
                                <th
                                    v-for="(item, index) in rowData.data_term"
                                    :key="index"  style="min-width: 100px;"
                                >
                                    {{item.term}}
                                </th>
                                <th >Total</th>
                            </tr>
                            <template v-for="itermPerMc in rowData.by_term">
                                <tr>
                                    <td style="white-space: nowrap;text-align: left;">{{itermPerMc.name}}</td>
                                    <td v-for="(item, index) in itermPerMc.data_per_term"
                                    :key="index" >{{item.total_per_term}}</td>
                                    <td >{{itermPerMc.total_all_term}}</td>
                                </tr>
                            </template>
                        </table>
                    </div>
                </div>
            </div>
            
            <div class="col-md-6 mb-primary">
                <div class="card card-with-shadow border-0 h-100" v-if="!preloader">
                    <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
                        <h5 class="card-title mb-0">{{ title_report }}</h5>
                    </div>
                    <div class="card-body">
                        <app-chart class="mb-primary"
                                    type="dough-chart"
                                    :height="230"
                                    :labels="rowData.data_chart.labels"
                                    :data-sets="[rowData.data_chart.dataSet]"/>
                        <div class="chart-data-list">
                            <div class="row">
                                <div class="col-12"
                                        v-for="(item, index) in rowData.chartElement" :key="index">
                                    <div class="data-group-item" :style="item.color">
                                        <span class="square" :style="item.background_color"/>
                                        {{item.key}}
                                        <span class="value">{{item.value}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from '../../../../Config/ApiUrl';
import { FormMixin } from "./FormMixin.js";

export default {
    extends: CoreLibrary,
    name: "InquiryByMarketingChannels",
    mixins: [FormMixin],
	data() {
		return {
            semesterId: null,
			semesterList : [],
            input_semester:{},
            title_report : 'Inquiry Source',
            titleChart:'Inquiry Source',
            rowData: {
                data_term:[],
                by_term:[],
                data_chart:{
                    labels:[],
                    dataSets:{}
                },
                chartElement:[]
            },
			preloader: true
        }
    },
    mounted() {
    },
    created() {
        this.initSemester();
    },
    methods: {
         async initSemester() {
            const resSemester = await axios.get(
                `/report/get-semester`
            );

            resSemester.data.data.forEach((item) => {
                this.semesterList.push({
                    id: item.id,
                    nama: item.nama,
                });
            });

            if (this.semesterList.length > 0) {
                this.semesterId = this.semesterList[0].id;
                this.input_semester = this.semesterList[0];
                this.title_report = 'Inquiry Source '+this.semesterList[0].nama;
                this.loadData(this.semesterId);
            }
        },
        async loadData(semesterId = null) {
            try {
			    this.preloader= true;
                const res = await axios.get(
                    `/report/get-data-inquiry-by-marketing-channels`,
                    {
                        params: {
                            semester: semesterId
                        }
                    }
                );

                this.rowData = Array.isArray(res.data) ? res.data : res.data || [];
                this.preloader= false;
            } catch (err) {
                this.rowData = {};
                this.preloader= false;
            }
        },
		setSemesterValue(data) {
			this.semesterId = data.id;
            this.input_semester=data;
            this.title_report = 'Inquiry Source '+data.nama;
            this.loadData(this.semesterId);
		}
    }
}
</script>
<style scoped>
    .table-Report{
        width: 100%;
        border: 1px solid black;
    }
    .table-Report th{
        background: #007bff;
        color: white;
        padding: 10px;
        text-align: center;
        font-size: 17px;
        border: 1px solid black;
    }
    .table-Report td{
        background: white;
        font-size: 14px;
        color: black;
        padding: 10px;
        text-align: center;
        border: 1px solid black;
    }
    .header-weekly{
        white-space: nowrap;
        
    }
    .table-wrapper {
        width: 100%;
        overflow-x: auto;
    }
    .table-Report {
        border-collapse: collapse;
    }
    .lf-0{
        position: sticky;
        left: 0;
    }
</style>
